import { Host, h } from "@stencil/core";
import { FallbackRenderInfo } from "../../utils/FallbackRenderInfo";
export class ApieFormSelect {
    constructor() {
        this.subElements = undefined;
        this.name = undefined;
        this.label = null;
        this.value = undefined;
        this.internalState = {};
        this.options = [];
        this.renderInfo = new FallbackRenderInfo();
        this.serverValidationError = {};
        this.touched = false;
    }
    renderSelect() {
        var _a, _b, _c;
        return this.renderInfo.renderSingleInput(['select'], {
            name: this.name,
            label: (_a = this.label) !== null && _a !== void 0 ? _a : undefined,
            value: (_c = (_b = this.internalState) === null || _b === void 0 ? void 0 : _b._split) !== null && _c !== void 0 ? _c : null,
            disabled: this.options.length === 0,
            valueChanged: (newValue) => {
                var _a, _b;
                const internalState = this.internalState ? Object.assign({}, this.internalState) : {};
                const prevSplit = (_a = internalState._split) !== null && _a !== void 0 ? _a : null;
                internalState._split = newValue;
                if (prevSplit) {
                    internalState[prevSplit] = this.value;
                }
                this.value = newValue ? ((_b = internalState[newValue]) !== null && _b !== void 0 ? _b : null) : null;
                this.internalState = internalState;
                this.triggerInternalState.emit({
                    name: this.name,
                    value: this.internalState,
                    force: true
                });
                this.triggerChange.emit({
                    name: this.name,
                    value: this.value,
                    force: true
                });
            },
            touched: this.touched,
            onTouched: () => this.touched = true,
            additionalSettings: {
                options: this.options,
            },
            validationResult: {
                valid: true,
                messages: []
            },
            serverValidationError: this.serverValidationError,
            renderInfo: this.renderInfo,
            currentFieldWrapper: this.renderInfo.createFieldWrapper(),
        });
    }
    componentWillLoad() {
        this.sanitizeInternalState();
    }
    sanitizeInternalState() {
        var _a;
        const curValue = this.internalState._split;
        for (let option of this.options) {
            if (option.value === curValue) {
                return;
            }
        }
        this.internalState._split = (_a = this.options[0]) === null || _a === void 0 ? void 0 : _a.value;
        this.internalState = Object.assign({}, this.internalState);
        this.triggerInternalState.emit({
            name: this.name,
            value: this.internalState,
            force: true
        });
    }
    render() {
        return (h(Host, { key: '983d9ff2621927dc50e69a51192921ea6a265a31' }, h("div", { key: '992fb06b2ca257ab96daaf704a5841189f84a693' }, this.renderSelect(), h("slot", { key: '91d73a8f9ee763ff6bf3aeb3b7277f34bb5b7df6' }))));
    }
    static get is() { return "apie-form-select"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-form-select.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-form-select.css"]
        };
    }
    static get properties() {
        return {
            "subElements": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "VNode[]",
                    "resolved": "VNode[]",
                    "references": {
                        "VNode": {
                            "location": "import",
                            "path": "@stencil/core",
                            "id": "node_modules::VNode"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                }
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "name",
                "reflect": true
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "label",
                "reflect": true,
                "defaultValue": "null"
            },
            "value": {
                "type": "unknown",
                "mutable": true,
                "complexType": {
                    "original": "Record<string, any>",
                    "resolved": "{ [x: string]: any; }",
                    "references": {
                        "Record": {
                            "location": "global",
                            "id": "global::Record"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                }
            },
            "internalState": {
                "type": "unknown",
                "mutable": true,
                "complexType": {
                    "original": "Record<string, any>",
                    "resolved": "{ [x: string]: any; }",
                    "references": {
                        "Record": {
                            "location": "global",
                            "id": "global::Record"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "{}"
            },
            "options": {
                "type": "unknown",
                "mutable": true,
                "complexType": {
                    "original": "Array<Option>",
                    "resolved": "Option[]",
                    "references": {
                        "Array": {
                            "location": "global",
                            "id": "global::Array"
                        },
                        "Option": {
                            "location": "import",
                            "path": "../../utils/RenderInfo",
                            "id": "src/utils/RenderInfo.tsx::Option"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "[]"
            },
            "renderInfo": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "RenderInfo",
                    "resolved": "RenderInfo",
                    "references": {
                        "RenderInfo": {
                            "location": "import",
                            "path": "../../utils/RenderInfo",
                            "id": "src/utils/RenderInfo.tsx::RenderInfo"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "new FallbackRenderInfo()"
            },
            "serverValidationError": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "NestedRecord<string>",
                    "resolved": "{ [key: string]: NestedRecordField<string>; }",
                    "references": {
                        "NestedRecord": {
                            "location": "import",
                            "path": "../../components",
                            "id": "src/components.d.ts::NestedRecord"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "{}"
            }
        };
    }
    static get states() {
        return {
            "touched": {}
        };
    }
    static get events() {
        return [{
                "method": "triggerChange",
                "name": "triggerChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "ChangeEvent",
                    "resolved": "ChangeEvent",
                    "references": {
                        "ChangeEvent": {
                            "location": "import",
                            "path": "../../utils/utils",
                            "id": "src/utils/utils.ts::ChangeEvent"
                        }
                    }
                }
            }, {
                "method": "triggerInternalState",
                "name": "triggerInternalState",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "ChangeEvent",
                    "resolved": "ChangeEvent",
                    "references": {
                        "ChangeEvent": {
                            "location": "import",
                            "path": "../../utils/utils",
                            "id": "src/utils/utils.ts::ChangeEvent"
                        }
                    }
                }
            }];
    }
    static get watchers() {
        return [{
                "propName": "internalState",
                "methodName": "sanitizeInternalState"
            }, {
                "propName": "value",
                "methodName": "sanitizeInternalState"
            }];
    }
}
//# sourceMappingURL=apie-form-select.js.map
